import Card, { CardTitle } from "./Card";
import React, { useState } from "react";
import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "../../posts/constants";
import HorizontalBarChart from "components/HorizontalBarChart";
import CompareModal from "./CompareModal";
import { COLORS } from "utils/styles.js";
import { getAudienceEmoji } from "posts/constants";

export default function AgeCard({ activeAudience }) {
  const renderData = (audience) => {
    // Note: Color is added for the onMouseOver() function in DonutGraph component
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return [
          { x: "65+", y: 29 },
          { x: "55-64", y: 22 },
          { x: "45-54", y: 16 },
          { x: "35-44", y: 13 },
          { x: "25-34", y: 11 },
          { x: "18-24", y: 8 },
        ];
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return [
          { x: "65+", y: 25 },
          { x: "55-64", y: 19 },
          { x: "45-54", y: 17 },
          { x: "35-44", y: 18 },
          { x: "25-34", y: 13 },
          { x: "18-24", y: 8 },
        ];
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return [
          { x: "65+", y: 16 },
          { x: "55-64", y: 16 },
          { x: "45-54", y: 14 },
          { x: "35-44", y: 22 },
          { x: "25-34", y: 23 },
          { x: "18-24", y: 9 },
        ];
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return [
          { x: "65+", y: 20 },
          { x: "55-64", y: 18 },
          { x: "45-54", y: 12 },
          { x: "35-44", y: 18 },
          { x: "25-34", y: 20 },
          { x: "18-24", y: 11 },
        ];
    }
  };

  const renderColorScale = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return COLORS.TOUGH_COOKIES_PALETTE;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return COLORS.DONT_TREAD_ON_ME_PALETTE;
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return COLORS.PEOPLE_POWER_PALETTE;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return COLORS.IF_YOU_SAY_SO_PALETTE;
    }
  };

  const [showCompare, setShowCompare] = useState(false);

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Age
      </CardTitle>

      <HorizontalBarChart
        data={renderData(activeAudience)}
        colors={renderColorScale(activeAudience)}
      />

      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>Compare Audiences – Age</CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`age-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    <HorizontalBarChart
                      data={renderData(type)}
                      colors={renderColorScale(type)}
                    />
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}
